import React from "react";

const reviews = [
  [
    "Everyone was obsessed with the booth! The pictures came out gorgeous, and the attendant made it so easy and fun.",
    "Jessica R.",
  ],
  [
    "The setup looked incredible and added such a cool touch to our venue. Guests kept going back for more photos — total hit!",
    "Ryan M.",
  ],
  [
    "The glam filter made us all look amazing. It honestly felt like we were on a red carpet.",
    "Tanya P.",
  ],
  [
    "They handled everything from start to finish. Staff was friendly, and the quality of the photos was top-notch.",
    "Michael D.",
  ],
  [
    "Our guests couldn’t stop sharing their photos on Instagram. It brought so much energy and fun to the night!",
    "Alina S.",
  ],
  [
    "I booked them for my wedding, and it was hands down the best decision. The photos are stunning, and we got them instantly!",
    "Samantha L.",
  ],
];

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      className="py-20 bg-slate-900 text-white"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
            Reviews
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">
            Loved by Event Planners & Guests
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map(([text, name], i) => (
            <div
              key={name}
              className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 border border-white/10 rounded-3xl p-6 shadow-xl shadow-black/60 animate-fade-up"
              style={{ animationDelay: `${i * 0.07}s` }}
            >
              <div className="text-[#E34364] text-3xl mb-3">“</div>
              <p className="text-sm text-gray-100">{text}</p>
              <p className="mt-4 text-sm font-semibold text-white">— {name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
